import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

const Benefits = () => {
	const { $t } = useIntl();

	const benefits = [
		{
			image: '/assets/Images/benefits/HighSpeedTransportation.jpeg',
			imageAlt: 'High-Speed Transportation',
			title: $t({ id: 'benefitsCardTitle1' }),
		},
		{
			image: '/assets/Images/benefits/EnsuringSaftyOfLoading.jpeg',
			imageAlt: 'Assurance of Safe Loading and Transportation of Goods',
			title: $t({ id: 'benefitsCardTitle2' }),
		},
		{
			image: '/assets/Images/benefits/ReliableInernationalPartners.jpeg',
			imageAlt: 'Multiple Trusted and Reputable Key International Partners',
			title: $t({ id: 'benefitsCardTitle3' }),
		},
		{
			image: '/assets/Images/benefits/TracingLocation.jpeg',
			imageAlt:
				'Smart Tracking and Monitoring of Shipments in All Transit Countries',
			title: $t({ id: 'benefitsCardTitle4' }),
		},
		{
			image: '/assets/Images/benefits/HumanResource.jpeg',
			imageAlt:
				'Specialized Personnel for Unloading, Loading, and Customs Clearance Processes',
			title: $t({ id: 'benefitsCardTitle5' }),
		},
		{
			image: '/assets/Images/benefits/EnsuringSaftyDelivary.jpeg',
			imageAlt: 'Assurance of Safe Delivery of Goods at Destination',
			title: $t({ id: 'benefitsCardTitle6' }),
		},
		{
			image: '/assets/Images/benefits/ExpertAdvice.jpeg',
			imageAlt: 'Expert Advice for Clients and Exporters',
			title: $t({ id: 'benefitsCardTitle7' }),
		},
		{
			image: '/assets/Images/benefits/HandOverTrainWagon.jpeg',
			imageAlt: 'Allocation of High-Quality Railcars at the Best Price',
			title: $t({ id: 'benefitsCardTitle8' }),
		},
		{
			image: '/assets/Images/benefits/BillPayment.jpeg',
			imageAlt: 'Capability to Pay Invoices in All Regional Countries with Various Payment Methods',
			title: $t({ id: 'benefitsCardTitle9' }),
		},
		{
			image: '/assets/Images/benefits/InformationTechnology.jpeg',
			imageAlt:
				'Intelligent Use of Information Technology in Process Management and Specialized Customer Services',
			title: $t({ id: 'benefitsCardTitle10' }),
		},
	];

	return (
		<Grid
			display={'grid'}
			gap={'40px'}
			px={{ xs: '10px', xxs: '32px', md: '103px' }}
		>
			<Typography
				variant={'h2'}
				display={'flex'}
				justifyContent={'center'}
				fontSize={'25px'}
			>
				{$t({ id: 'benefitsTitleMainPage' })}
			</Typography>
			<Grid
				display={'flex'}
				flexWrap={'wrap'}
				alignItems={'start'}
				justifyContent={'center'}
				gap={'24px'}
			>
				{benefits.map(({ image, imageAlt, title }, index) => (
					<BenefitItem
						key={index}
						{...{ image, imageAlt, title }}
					/>
				))}
			</Grid>
		</Grid>
	);
};

const BenefitItem = ({ image, imageAlt, title }) => {
	return (
		<Grid
			display={'grid'}
			width={'200px'}
			gap={'24px'}
			justifyItems={'center'}
		>
			<Grid
				display={'flex'}
				alignItems={'center'}
				justifyContent={'center'}
				width={'150px'}
				height={'150px'}
				// padding={'20px'}
				boxShadow={'2px 4px 15px 0px #00000026'}
				bgcolor={'#FFEFD0'}
				borderRadius={'4px'}
				overflow={'hidden'}
			>
				<img
					src={image}
					alt={imageAlt}
					style={{
						width: '100%',
						height: '100%',
						objectFit: 'contain',
					}}
				/>
			</Grid>
			<Typography
				fontSize={'14px'}
				color={'#444A5D'}
				textAlign={'center'}
			>
				{title}
			</Typography>
		</Grid>
	);
};

export default Benefits;
